import { formatAmount, normalizeAmount } from 'lib/utils/amount';

import AttachmentClass from 'lib/project/classes/Attachment';

import Widget from 'services/widget/Widget';

class NotificationWidget extends Widget {
  constructor(data) {
    super();

    this.code = null;
    this.currency = data.currency;
    this.type = 'NOTIFICATION';
    this.variants = [
      new Variant({ currency: data.currency }),
    ];
  }

  addVariant() {
    this.variants.push(new Variant({
      currency: this.currency,
    }));
  }

  deleteVariant(idx) {
    this.variants.splice(idx, 1);
  }

  setData(data) {
    this.code = data?.code;
    this.variants = data?.variants
      .map(variant => new Variant({
        ...variant,
        currency: data.currency,
      }));
  }

  getData() {
    return {
      code: this.code,
      status: this.status,
      type: this.type,
      variants: this.variants
        .map(variant => {
          return {
            amountFrom: variant.normalizeAmount(),
            attachment: variant.attachment.getData(),
          };
        }),
    };
  }
}

class Variant {
  constructor(data) {
    this.amountFrom = formatAmount(data.amountFrom, {
      significant_zeros: data.currency.significant_zeros,
      type: data.currency.type,
    });

    this.attachment = new AttachmentClass(data?.attachment);
    this.currency = data.currency;
  }

  normalizeAmount() {
    return normalizeAmount(this.amountFrom, this.currency);
  }
}

export default NotificationWidget;
